import styled from 'styled-components';
export const ProductCardContainer = styled.div ``;
export const TabsWrapper = styled.div `
  ${(props) => props.theme.mixins.mobile(`
    padding-left: 15px;
    padding-right: 15px;

  `)}
`;
